var _desc, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCommonFileQuestion = function SvgCommonFileQuestion(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    id: "Common-File-Question--Streamline-Streamline-3.0.svg",
    height: 24,
    width: 24,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Common File Question Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#030f40",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M17.25 23.25a6 6 0 1 0 0 -12 6 6 0 0 0 0 12Z",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#030f40",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.375 16.125A1.875 1.875 0 1 1 17.25 18",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#030f40",
    d: "M17.25 21a0.375 0.375 0 0 1 0 -0.75",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#030f40",
    d: "M17.25 21a0.375 0.375 0 0 0 0 -0.75",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#030f40",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.25 20.25h-6a1.5 1.5 0 0 1 -1.5 -1.5V2.25a1.5 1.5 0 0 1 1.5 -1.5h10.629a1.5 1.5 0 0 1 1.06 0.439l2.872 2.872a1.5 1.5 0 0 1 0.439 1.06V8.25",
    strokeWidth: 1.5
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCommonFileQuestion);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/common-file-question.682450a2ff32044494d95ddaf68e2e29.svg";